import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import GranjasCarousel from "../GranjasCarousel/GranjasCarousel";
import AddGranjaForm from "../../Granja/Add/Forms/AddFarmForm/AddGranjaForm";
import AddControlAvesForm from "../../Granja/Add/Forms/AddControlAvesForm/AddControlAvesForm";
import AddControlAlimentoForm from "../../Granja/Add/Forms/AddControlAlimentoForm/AddControlAlimentoForm";
import AddProduccionHuevosForm from "../../Granja/Add/Forms/AddProduccionHuevosForm/AddProduccionHuevosForm";
import AddAveForm from "../../Granja/Add/Forms/AddBatchForm/AddAveForm";
import AddGalponForm from "../../Granja/Add/Forms/AddGalponForm/AddGalponForm";
import AddAlimento from "../../Granja/Add/Buttons/AddAlimento/AddAlimento";
import AddAlimentoForm from "../../Granja/Add/Forms/AddAlimentoForm/AddAlimentoForm";
import AddTiposHuevosForm from "../../Granja/Add/Forms/AddTiposHuevosForm/AddTiposHuevosForm";
import "./GranjasTable.css";
import { useShoppingContext } from "../../context/ShoppingContext";

const GranjasTable = () => {
  const {
    granjas,
    fetchMisGranjas,
    setShowAddGranja,
    showAddGranja,
    galpones,
    aves,
    alimentos,
    fetchMisGalpones,
    fetchMisAves,
    fetchAlimentos,
    showAddControlAves,
    showAddControlAlimentos,
    setShowAddControlAlimentos,
    showAddProduccion,
    setShowAddProduccion,
    fetchProduccionHuevos,
    showAddGalpon,
    setShowAddGalpon,
    showAddAves,
    setShowAddAves,
    showAddAlimento,
    setShowAddAlimento,
    setShowFarmer,
    setFarmerMessage,
    setHandleAction,
    setActionButtonText,
    setIsDataFetched,
    isDataFetched,
    tiposHuevos,
    showAddEgg,
    setShowAddEgg,
    fetchTiposHuevos,
  } = useShoppingContext();

  const handleFeedAves = () => {
    if (alimentos.length === 0) {
      // Mostrar el FarmerMessage si no hay alimentos
      setShowFarmer(true);
      setFarmerMessage(
        "No tienes alimentos. Por favor, crea un tipo de alimento e ingresa la cantidad que compraste para alimentar a tus aves."
      );
      setActionButtonText("Crear Alimento");
      setHandleAction(() => () => {
        setShowAddAlimento(!showAddAlimento);
        setShowFarmer(false); // Ocultar el FarmerMessage después de la acción
      });
    } else {
      // Mostrar el formulario de control de alimentos si ya existen
      setShowAddControlAlimentos(!showAddControlAlimentos);
    }
  };

  const handleCollect = () => {
    if (tiposHuevos.length === 0) {
      // Mostrar el FarmerMessage si no hay alimentos
      setShowFarmer(true);
      setFarmerMessage(
        "Antes de recolectar huevos, clasifica los tipos de huevos que existen en tu granja, por ejemplo: Comerciales."
      );
      setActionButtonText("Añadir Tipo de Huevos");
      setHandleAction(() => () => {
        setShowAddEgg(!showAddEgg);
        setShowFarmer(false); // Ocultar el FarmerMessage después de la acción
      });
    } else {
      // Mostrar el formulario de producción de huevos si ya existen tipos de huevos
      setShowAddProduccion(!showAddProduccion);
    }
  };

  // Realizar todos los fetches en un solo useEffect
  useEffect(() => {
    const fetchData = async () => {
      await fetchProduccionHuevos();
      await fetchMisGranjas();
      await fetchMisGalpones();
      await fetchMisAves();
      await fetchAlimentos();
      await fetchTiposHuevos();

      setIsDataFetched(true); // Marcar los datos como cargados
    };
    fetchData();
  }, [
    fetchMisGalpones,
    fetchMisGranjas,
    fetchAlimentos,
    fetchMisAves,
    fetchProduccionHuevos,
    fetchTiposHuevos,
    setIsDataFetched,
  ]);

  return (
    <>
      {!isDataFetched ? (
        <div>Cargando datos...</div> // Muestra un mensaje de carga mientras los datos se están obteniendo
      ) : (
        <>
          <div className="div-1">
            {/* Div para añadir aves */}
            <div
              className="nueva-granja"
              onClick={() => setShowAddAves(!showAddAves)}
            >
              <FontAwesomeIcon icon={faPlus} /> Aves
            </div>

            {/* Div para añadir Nuevo Galpón */}
            <div
              className="nueva-granja"
              onClick={() => setShowAddGalpon(!showAddGalpon)}
            >
              <FontAwesomeIcon icon={faPlus} /> Galpones
            </div>
            {/* Div para añadir Nueva Granja */}
            <div
              className="nuevo-galpon"
              onClick={() => setShowAddGranja(!showAddGranja)}
            >
              <FontAwesomeIcon icon={faPlus} /> Nueva Granja
            </div>
          </div>
          {granjas.length === 0 ? (
            <div className="mb-3">
              <div
                className="card granja-card btn-green-outline shadow-sm d-flex justify-content-center align-items-center"
                onClick={() => setShowAddGranja(!showAddGranja)}
                style={{ cursor: "pointer", margin: "0 auto" }}
              >
                <h5>Crea tu granja</h5>
              </div>
            </div>
          ) : (
            <div>
              <GranjasCarousel />
            </div>
          )}

          {galpones.length > 0 && aves.length > 0 ? (
            <>
              {" "}
              <div className="produccion">
                {/* Div para Recolectar Huevos */}
                <div className="AddHuevo">
                  {" "}
                  <button
                    className={"btn-show btn-green"}
                    onClick={() => setShowAddEgg(!showAddEgg)}
                    disabled={false} // Desactivamos el botón temporalmente
                  >
                    {!showAddEgg ? `Nuevo Tipo de Huevo` : ``}{" "}
                    <FontAwesomeIcon icon={!showAddEgg ? faPlus : faMinus} />
                  </button>
                  {showAddEgg && <AddTiposHuevosForm />}
                </div>

                <div>
                  <div
                    className="home-button shadow-sm align-items-center"
                    onClick={handleCollect}
                  >
                    <h5>Recolectar Huevos</h5>
                    <div className="maple-huevos"></div>
                  </div>
                </div>

                {/* Div para Alimentar Aves */}
                <div className="mt-2">
                  <div
                    className={`home-button shadow-sm align-items-center`}
                    onClick={handleFeedAves}
                  >
                    <h5>Alimentar Aves</h5>
                    <div className="cartoon-chicken"></div>
                  </div>
                </div>
                <AddAlimento />
              </div>
            </>
          ) : (
            <>
              {/* Div para Agregar Galpones */}
              <div className="col-md-4 mb-3">
                <div
                  className={`card granja-card shadow-sm d-flex justify-content-center align-items-center ${
                    galpones.length > 0 ? "btn-disabled" : "btn-green btn-now"
                  }`}
                  onClick={() =>
                    galpones.length === 0 && setShowAddGalpon(!showAddGalpon)
                  }
                >
                  <h5>Paso 1: Construir Galpón</h5>
                </div>
              </div>
              {/* Div para Agregar Aves */}
              <div className="col-md-4 mb-3">
                <div
                  className={`card granja-card shadow-sm d-flex justify-content-center align-items-center ${
                    galpones.length === 0 ? "btn-disabled" : "btn-green btn-now"
                  }`}
                  onClick={() =>
                    galpones.length > 0 && setShowAddAves(!showAddAves)
                  } // Enable only if galpones exist
                >
                  <h5>Paso 2: Agregar Aves</h5>
                </div>
              </div>
            </>
          )}

          {showAddGranja && <AddGranjaForm />}
          {showAddControlAves && <AddControlAvesForm />}
          {showAddControlAlimentos && <AddControlAlimentoForm />}
          {showAddProduccion && <AddProduccionHuevosForm />}
          {showAddAves && <AddAveForm />}
          {showAddGalpon && <AddGalponForm />}
          {showAddAlimento && <AddAlimentoForm />}
        </>
      )}
    </>
  );
};

export default GranjasTable;
